import { render, staticRenderFns } from "./downRate.vue?vue&type=template&id=22f32c9f&scoped=true&"
import script from "./downRate.vue?vue&type=script&lang=js&"
export * from "./downRate.vue?vue&type=script&lang=js&"
import style0 from "./downRate.vue?vue&type=style&index=0&id=22f32c9f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f32c9f",
  null
  
)

export default component.exports